import { VITRIN_API_URL } from '@/constants/config';
import { encodeQuery } from '~/modules/common/utils/routingUtils';

const base = VITRIN_API_URL + '/v1';

/**
 * Article Service
 *
 * @param {object} http axios instance from nuxt context
 * @param {object} cookies cookies from nuxt context
 */
export const vitrinService = (http, cookies) => ({
  /**
   * Get Vitrin Feed
   * @param {string} categoryId category id
   * @param {number} [param.pagination] page optional
   * @param {number} [param.limit] page optional
   */
  async getVitrinFeed(categoryId = '', page = 1, limit = 15) {
    const queryParams = encodeQuery({ pagination: page, limit });
    const { data, pagination } = await http.$get(`${base}/feed/${categoryId}${queryParams}`);

    return { data, pagination };
  },
});
